import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Wrapper = styled.div`
  min-height: 100vh;
  background: #fafafa;
  padding: 40px 20px;
`;

const Container = styled.div`
  max-width: 900px;
  margin: auto;
  background: #fff;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
`;

const Title = styled.h1`
  font-size: 32px;
  margin-bottom: 30px;
`;

const Section = styled.div`
  margin-bottom: 24px;
`;

const SubTitle = styled.h3`
  font-size: 18px;
  margin-bottom: 8px;
`;

const Text = styled.p`
  font-size: 15px;
  line-height: 1.7;
  color: #555;
  white-space: pre-line; /* preserve newlines from translation JSON */
`;

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Container>
        <Title>{t("Privacy.title")}</Title>
        <Text>{t("Privacy.description")}</Text>

        <Section>
          <SubTitle>{t("Privacy.responsible_title")}</SubTitle>
          <Text>{t("Privacy.responsible")}</Text>
        </Section>

        <Section>
          <SubTitle>{t("Privacy.general_title")}</SubTitle>
          <Text>{t("Privacy.general")}</Text>
        </Section>

        <Section>
          <SubTitle>{t("Privacy.collection_title")}</SubTitle>

          <SubTitle>{t("Privacy.collection_a_title")}</SubTitle>
          <Text>{t("Privacy.collection_a")}</Text>

          <SubTitle>{t("Privacy.collection_b_title")}</SubTitle>
          <Text>{t("Privacy.collection_b")}</Text>

          <SubTitle>{t("Privacy.collection_c_title")}</SubTitle>
          <Text>{t("Privacy.collection_c")}</Text>
        </Section>

        <Section>
          <SubTitle>{t("Privacy.stripe_title")}</SubTitle>
          <Text>{t("Privacy.stripe")}</Text>
        </Section>

        <Section>
          <SubTitle>{t("Privacy.cookies_title")}</SubTitle>
          <Text>{t("Privacy.cookies")}</Text>
        </Section>

        <Section>
          <SubTitle>{t("Privacy.sharing_title")}</SubTitle>
          <Text>{t("Privacy.sharing")}</Text>
        </Section>

        <Section>
          <SubTitle>{t("Privacy.storage_title")}</SubTitle>
          <Text>{t("Privacy.storage")}</Text>
        </Section>

        <Section>
          <SubTitle>{t("Privacy.rights_title")}</SubTitle>
          <Text>{t("Privacy.rights")}</Text>
        </Section>

        <Section>
          <SubTitle>{t("Privacy.security_title")}</SubTitle>
          <Text>{t("Privacy.security")}</Text>
        </Section>

        <Section>
          <SubTitle>{t("Privacy.changes_title")}</SubTitle>
          <Text>{t("Privacy.changes")}</Text>
        </Section>
      </Container>
    </Wrapper>
  );
};

export default PrivacyPolicy;
